<template>
	<div class="modal-column">
		<div class="modal-column-body">
			<Form ref="form" mode="block" :rules="{}" :model="formData">
				<FormItem label="编码" prop="code" required>
					<NumberInput v-model="formData.code"/>
				</FormItem>
				<FormItem label="名称" prop="name" required>
					<Input type="text" v-model.trim="formData.name"/>
				</FormItem>
				<FormItem label="备注" prop="remark">
					<Input type="text" v-model="formData.remark"/>
				</FormItem>
				<FormItem label="现金流类别" prop="category">
					<Input type="text" v-model="formData.category"/>
				</FormItem>
			</Form>
		</div>
		<div class="modal-column-btn modal-column-between">
			<vxe-button :loading="loading" icon="fa fa-close" @click="$emit('close')">取消</vxe-button>
			<vxe-button :loading="loading" status="primary" icon="fa fa-save" @click="onSave">保存</vxe-button>
		</div>
	</div>
</template>

<script>
/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
export default {
	name: "CashFlowForm"
}
</script>

<script setup>
import {reactive, ref, defineEmits, defineProps, toRefs} from "vue";
import {CashFlow} from "@/api/Auxiliary";
import {message} from "heyui.ext";
import {CopyObj} from "@/js/common/utils";

const emit = defineEmits(['close', 'success'])
const props = defineProps(['entity'])

const {entity} = toRefs(props)
const loading = ref(false);
const form = ref(null);

const formData = reactive({
	accountSetsId: null,
	id: null,
	code: null,
	createTime: null,
	enable: null,
	mnemonics: null,
	name: null,
	remark: null,
	updateTime: null,
	category: null,
})

const onSave = () => {
	const validResult = form.value.valid();
	if (validResult.result) {
		loading.value = true;
		CashFlow.save(formData).then(() => {
			message("保存成功~")
			emit('success')
		}).finally(() => loading.value = false)
	}
}

CopyObj(formData, entity.value);
</script>
